/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,size
10,20,30
25,35,90`)
};

const es_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,tamaño
10,20,30
25,35,90`)
};

const de_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,size
10,20,30
25,35,90`)
};

const nl_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,grootte
10,20,30
25,35,90`)
};

const fr_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,taille
10,20,30
25,35,90`)
};

const it_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,dimensione
10,20,30
25,35,90`)
};

const pt_br2_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,tamanho
10,20,30
25,35,90`)
};

const pt_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,tamanho
10,20,30
25,35,90`)
};

const ja_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,size
10,20,30
25,35,90`)
};

const zh_bubble_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,size
10,20,30
25,35,90`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_placeholder", locale)
	if (locale === "en") return en_bubble_placeholder(inputs)
	if (locale === "es") return es_bubble_placeholder(inputs)
	if (locale === "de") return de_bubble_placeholder(inputs)
	if (locale === "nl") return nl_bubble_placeholder(inputs)
	if (locale === "fr") return fr_bubble_placeholder(inputs)
	if (locale === "it") return it_bubble_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_placeholder(inputs)
	if (locale === "pt") return pt_bubble_placeholder(inputs)
	if (locale === "ja") return ja_bubble_placeholder(inputs)
	return zh_bubble_placeholder(inputs)
};